// Components==============
import { faStar, faUsers, faBookmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import {
    experienceNeededOptions,
    targetGroupOptions,
    themeOptions,
} from 'utilities/filterOptions';
import './index.module.scss';
import ParticipantsCounter from './ParticipantsCounter/ParticipantsCounter';
// =========================

const combineArrayIntoString = (arr) => {
    const preppedArr = arr.map((item, i) => {
        let lowerCased = item.toLowerCase();
        if (item === 'OP' || item === 'OOP') {
            lowerCased = item;
        }
        return i === 0
            ? item
            : arr.length === 2 && i === 1
            ? ` & ${lowerCased}`
            : arr.length > 2 && i === arr.length - 1
            ? ` & ${lowerCased}`
            : `, ${lowerCased}`;
    });

    return preppedArr.join('');
};

export default function TrainingCard({ isSchoolsTrainingPage, network, ...training }) {
    const targetGroup = training?.custom_target_group || (
        training?.target_groups &&
        combineArrayIntoString(Object.entries(training.target_groups)
            .map((t) =>
                t[1]
                    ? targetGroupOptions.find((e) => e.short === t[0])?.long
                    : undefined
            )
            .filter((exists) => exists)));

    const themes =
        training?.themes &&
        Object.entries(training.themes)
            .map((t) =>
                t[1]
                    ? themeOptions.find((e) => e.short === t[0])?.long
                    : undefined
            )
            .filter((exists) => exists);

    // format start date
    const formattedDate = new Date(training.start_date).toLocaleDateString(
        'nl-NL',
        {
            timeZone: 'Europe/Amsterdam',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }
    );

    const experienceNeeded =
        training?.experience_needed &&
        Object.entries(training.experience_needed)
            .map((t) =>
                t[1]
                    ? experienceNeededOptions.find((e) => e.short === t[0])
                          ?.long
                    : undefined
            )
            .filter((exists) => exists)
            .sort((a, b) => {
                let sizeA = 0;
                let sizeB = 0;
                if (a === 'In opleiding') {
                    sizeA = 1;
                } else if (a === 'Starter') {
                    sizeA = 2;
                } else if (a === 'Ervaren') {
                    sizeA = 3;
                } else if (a === 'Meester') {
                    sizeA = 4;
                }
                if (b === 'In opleiding') {
                    sizeB = 1;
                } else if (b === 'Starter') {
                    sizeB = 2;
                } else if (b === 'Ervaren') {
                    sizeB = 3;
                } else if (b === 'Meester') {
                    sizeB = 4;
                }

                return sizeA - sizeB;
            });

    const openInformationModal = useOpenUrlModal(
        `training-popup/${training?.id}`
    );

    return (
        <motion.div
            styleName="wrapper"
            onClick={() => openInformationModal()}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            initial={{ scale: 1 }}
        >
            <div
                styleName="header"
                style={{
                    background: '#FED230',
                }}
            />
            {training.start_date ? (
                <p styleName="startDate">{formattedDate}</p>
            ) : null}
            {!!training.image && (
                <img
                    alt="placeholder"
                    src={`/storage/${training.image}`}
                    styleName="image"
                />
            )}
            <div styleName="content">
                <h3>{training?.name}</h3>

                {!isSchoolsTrainingPage && (
                    <div styleName="labels">
                        {!!targetGroup && (
                            <div styleName="label">
                                <FontAwesomeIcon icon={faUsers} />
                                <p>{targetGroup}</p>
                            </div>
                        )}
                        {!network &&
                            <>
                                {!!themes && themes.length > 0 && (
                                    <div styleName="label">
                                        <FontAwesomeIcon icon={faBookmark} />
                                        <p>{combineArrayIntoString(themes)}</p>
                                    </div>
                                )}
                                {!!experienceNeeded && (
                                    <div styleName="label">
                                        <FontAwesomeIcon icon={faStar} />
                                        <p>
                                            {combineArrayIntoString(experienceNeeded)}
                                        </p>
                                    </div>
                                )}
                            </>
                        }
                    </div>
                )}
                {isSchoolsTrainingPage && (
                    <ParticipantsCounter
                        registrationsCount={training?.registrations_count}
                        maxParticipants={training?.max_participants}
                    />
                )}
            </div>
        </motion.div>
    );
}
